
const NAMESPACE = 'ordermage'

export type StorageKey<T> = {
  scope: string
  tenantId?: string | null
  version: number
  __brand?: T
}

export function key<T>(scope: string, version = 1, tenantId?: string | null): StorageKey<T> {
  return { scope, tenantId: tenantId ?? null, version }
}

function serialize<T>(k: StorageKey<T>): string {
  return [NAMESPACE, k.scope, k.tenantId ?? 'global', `v${k.version}`].join('.')
}

export function read<T>(k: StorageKey<T>): T | null {
  try {
    const raw = localStorage.getItem(serialize(k))
    if (!raw) return null
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export function write<T>(k: StorageKey<T>, value: T): void {
  try {
    localStorage.setItem(serialize(k), JSON.stringify(value))
  } catch {
    
  }
}

export function remove<T>(k: StorageKey<T>): void {
  try {
    localStorage.removeItem(serialize(k))
  } catch {
    
  }
}

export function purgeByScope(scope: string, tenantId?: string): void {
  const prefix = [NAMESPACE, scope, tenantId ?? ''].filter(Boolean).join('.')
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const k = localStorage.key(i)
    if (k && k.startsWith(prefix)) localStorage.removeItem(k)
  }
}
